export enum ABTestStatusEnum {
    Pending = 1,
    InProgress = 2,
    Failed = 3,
    Completed = 4,
    Stopped = 5,
    Calculating = 6,
}

export enum SegmentABMetricStatusEnum {
    Pending = 1,
    InProgress = 2,
    Completed = 3,
    Failed = 4,
}

export enum ABTestFailReasonEnum {
    None = 0,
    InternalError = 20,
    ExternalError = 21,
    LimitError = 11,
}
